import { render, staticRenderFns } from "./DashboardHub.vue?vue&type=template&id=1d4d0dcd&scoped=true"
import script from "./DashboardHub.vue?vue&type=script&lang=js"
export * from "./DashboardHub.vue?vue&type=script&lang=js"
import style0 from "./DashboardHub.vue?vue&type=style&index=0&id=1d4d0dcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4d0dcd",
  null
  
)

export default component.exports